<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表-修改优惠券
      -->
  <div v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">基本信息</div>
      <el-form-item label="卡包类型">
        <el-radio-group v-model="form.coupon_type">
          <el-radio :label="10">满减券</el-radio>
          <el-radio :label="20">折扣券</el-radio>
          <!-- <el-radio :label="30">提货卡</el-radio> -->
          <el-radio :label="50">签到红包</el-radio>
          <el-radio :label="60">幸运红包</el-radio>
          <el-radio :label="70">惊喜红包</el-radio>
          <el-radio :label="80">产品红包</el-radio>
          <el-radio :label="90">生日红包</el-radio>
          <el-radio :label="100">节日红包</el-radio>
          <el-radio :label="111">签到视频红包</el-radio>
        </el-radio-group>
      </el-form-item>

    <el-form-item label="节日日期" v-if="form.coupon_type == 100">
        <div class="d-s-c">
          <el-select 
            v-model="form.festival_name" 
            placeholder="请选择节日"
            style="width: 100%; margin-right: 10px;"
          >
            <el-option
              v-for="item in festivalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            <el-option label="自定义日期" value="custom"></el-option>
          </el-select>
          
          <el-date-picker
            v-if="form.festival_name === 'custom'"
            v-model="form.custom_festival_date"
            type="date"
            placeholder="选择自定义日期"
            value-format="MM-dd"
            style="width: 100%;"
          ></el-date-picker>
        </div>
        <div class="lh18 mt10 gray9" v-if="form.festival_name && form.festival_name !== 'custom'">
          <p>当前选择的节日日期: {{ getFestivalDate(form.festival_name) }}</p>
        </div>
      </el-form-item>

<el-form-item label="领取用户范围" prop="user_range">
  <el-radio-group v-model="form.user_range" @change="handleUserRangeChange">
    <el-radio :label="1">全部用户</el-radio>
    <el-radio :label="2">随机用户</el-radio>
    <el-radio :label="3">指定用户</el-radio>
  </el-radio-group>
  <el-button 
    v-if="form.user_range === 3" 
    type="primary" 
    size="mini" 
    @click="openUserDialog"
  >选择用户</el-button>
</el-form-item>

<!-- 用户选择对话框 -->
<el-dialog title="选择指定用户" :visible.sync="userDialogVisible">
  <el-transfer
  v-if="userList && userList.length > 0"
  v-model="form.user"
    :data="userList"
    :titles="['所有用户', '已选用户']"
    filterable
  ></el-transfer>
  <div slot="footer">
    <el-button @click="userDialogVisible = false">取消</el-button>
    <el-button type="primary" @click="confirmUserSelection">确定</el-button>
  </div>
</el-dialog>



      <el-form-item label="红包名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入红包名称"></el-input>
      </el-form-item>

      <!-- <el-form-item label="红包类型">
        <el-radio-group v-model="form.hongbao_type">
          <el-radio label="1">签到红包</el-radio>
          <el-radio label="2">幸运红包</el-radio>
          <el-radio label="3">惊喜红包</el-radio>
          <el-radio label="4">产品红包</el-radio>
          <el-radio label="5">生日红包</el-radio>
          <el-radio label="6">节日红包</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="红包背景图">
        <div
          v-if="form.bgImage"
          class="default-image-box"
          @click="bgUpload('bg')"
        >
          <div class="image-box">
            <img :src="form.bgImage.file_path" alt="bgImage" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteBgImg('bg')"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('bg')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>推荐尺寸：显示图片长宽为 1000×600</p>
        </div>
      </el-form-item>
      <el-form-item label="分享封面">
        <div
          v-if="form.shareImage"
          class="default-image-box"
          @click="bgUpload('share')"
        >
          <div class="image-box">
            <img :src="form.shareImage.file_path" alt="shareImage" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteBgImg('share')"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('share')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>尺寸：显示图片长宽为 500×400</p>
        </div>
      </el-form-item>
      <el-form-item label="兑换背景" v-if="form.coupon_type == 30">
        <div
          v-if="form.exchange_bg"
          class="default-image-box"
          @click="bgUpload('exchange_bg')"
        >
          <div class="image-box">
            <img :src="form.exchange_bg" alt="exchange_bg" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteBgImg('exchange_bg')"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('exchange_bg')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>建议尺寸：750*1334</p>
        </div>
      </el-form-item>
      <div v-if="form.coupon_type == 30">
        <el-form-item label="限制兑换时间">
          <el-radio-group v-model="form.exchange_type">
            <el-radio :label="0">不限制</el-radio>
            <el-radio :label="10">限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效兑换时间" v-if="form.exchange_type == 10">
          <el-date-picker
            v-model="form.exchange_time"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="兑换开始时间"
            end-placeholder="兑换结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </div>

      <el-form-item label="选择归属分销商" v-if="form.coupon_type == 30">
        <div class="d-s-s d-c">
          <el-button @click="openGetuser" icon="el-icon-plus"
            >选择分销商</el-button
          >
          <ul class="d-s-s select-user" v-if="referee">
            <li class="mr10 d-c-c d-c p-10-0">
              <img
                :src="referee.avatarUrl"
                class="radius"
                width="30"
                height="30"
              />
              <p class="lh18 ww100 text-ellipsis">{{ referee.nickName }}</p>
            </li>
            <li class="mr10 d-c-c d-c p-10-0" @click="deleteReferee">
              删除
            </li>
          </ul>
        </div>
      </el-form-item>

      <el-form-item
        label="卡包颜色"
        v-if="
          Number(form.coupon_type) === 10 || Number(form.coupon_type) === 20
        "
      >
        <el-radio-group v-model="form.color">
          <el-radio :label="10">蓝色</el-radio>
          <el-radio :label="20">红色</el-radio>
          <el-radio :label="30">紫色</el-radio>
          <el-radio :label="40">黄色</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="到期类型"
        v-if="
          Number(form.coupon_type) === 10 || Number(form.coupon_type) === 20
        "
      >
        <el-radio-group v-model="form.expire_type">
          <el-radio :label="10">领取后生效</el-radio>
          <el-radio :label="20">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <div
        v-if="
          Number(form.expire_type) === 10 &&
            (Number(form.coupon_type) === 10 || Number(form.coupon_type) === 20)
        "
      >
        <el-form-item label="有效天数">
          <el-input
            v-model="form.expire_day"
            placeholder="请输入有效天数"
            type="number"
          ></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="有效时间" v-if="Number(form.coupon_type) === 20">
          <el-date-picker
            v-model="form.active_time"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </div>

      <span v-if="Number(form.coupon_type) === 40">
        <div>
          <el-form-item label="充值卡激活赠送卡余额">
            <el-input
              v-model="form.price"
              :disabled="true"
              placeholder="请输入充值卡激活赠送卡余额"
              type="number"
            ></el-input>
          </el-form-item>
        </div>

        <div>
          <el-form-item label="充值卡激活费用">
            <el-input
              v-model="form.nprice"
              :disabled="true"
              placeholder="请输入充值卡激活费用"
              type="number"
            ></el-input>
          </el-form-item>
        </div>
      </span>

      <!--添加门店-->
      <Pickup
        :form="form"
        v-if="Number(form.coupon_type) === 30"
        :type="'edit'"
      ></Pickup>
      <Coupon :form="form" v-else-if="Number(form.coupon_type) != 40"></Coupon>

      <el-form-item label="使用说明" v-if="form.coupon_type != 40">
        <div class="edit_container">
          <Uediter
            :text="form.content"
            :config="ueditor.config"
            ref="ue"
            @contentChange="contentChangeFunc"
          ></Uediter>
        </div>
      </el-form-item>
      <!--选择用户-->
      <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button
          type="info"
          size="small"
          @click="cancelFunc"
          :loading="loading"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="onSubmit"
          :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>

    <!--详情附加图片组件-->
    <Upload
      v-if="isBgUpload"
      :config="{ total: 9 }"
      :isupload="isBgUpload"
      @returnImgs="returnBgImgFunc"
      >上传图片</Upload
    >
  </div>
</template>

<script>
import CouponApi from "@/api/coupon.js";
import UserApi from '@/api/user.js';
import { formatModel } from "@/utils/base.js";
import { mergeTable } from "@/utils/table.js";
import Coupon from "./part/Coupon";
import Pickup from "./part/Pickup";
import Upload from "@/components/file/Upload";
import Uediter from "@/components/UE.vue";
import GetUser from "@/components/user/GetReferee.vue";
export default {
  components: {
    Coupon,
    Pickup,
    Upload,
    Uediter,
    GetUser
  },
  data() {
    return {
          userList: [] ,// 从接口获取的用户数据
      /*form表单数据*/
      form: {
        product_id: 0,
        gtask_id: 0,
        // 所有红包类型的共有字段
        hongbao_att: 0, // 发送数量 (int)
         user_range: 1, // 默认全部用户
      user: [] ,// 存储选择的用户ID
        // 签到红包专用 (type=1)
        related_task: null, // 关联任务 (int)
        custom_festival_date:'',
        // 幸运红包专用 (type=2)
        day_random_given: 0, // 每日随机赠送数量 (int)
        day_max_given: 0, // 每日赠送上限 (int)
        day_vip_grab: 0, // 会员每日可抢次数 (int)
        start_grab: 1, // 从抢第几个红包开始 (int, 默认1)
        tip_grab: "", // 提示文字 (varchar)
        share_friend: 0, // 分享好友数量 (int)
        share_re_given: 0, // 分享成功赠送次数 (int)
        festival_name:'',
        // 惊喜红包专用 (type=3)
        hongbao_amount: 0, // 红包金额 (int)

        // 产品红包专用 (type=4)
        related_products: [], // 关联产品 (array of int)
        is_extral_reward: 0, // 是否有额外奖励 (int: 0-否 1-是)
        extral_reward: 0, // 额外奖励金额 (int)
        /*优惠券ID*/
        coupon_id: "",
        /*优惠券名称*/
        name: "",
        /*优惠券颜色*/
        color: "",
        /*优惠券类型*/
        coupon_type: "",
        /*减免金额*/
        reduce_price: "",
        /*折扣率*/
        discount: "",
        /*最低消费金额*/
        min_price: "",
        /*到期类型*/
        expire_type: "",
        exchange_type: "",
        exchange_time: "",
        /*有效天数*/
        expire_day: "",
        /*有效期*/
        active_time: "",
        /*发放量*/
        total_num: "",
        /*排序*/
        sort: 1,
        /*商品源数据*/
        tableData: [],
        /*商品列表*/
        product_list: [],
        product_del_ids: [],
        rules: {
      total_num: [
        { validator: this.validateTotalNum, trigger: 'blur' }
      ]
    },
        // 优惠券背景图
        bg_image: 0,
        bgImage: null,
        // 优惠券分享图片
        share_image: 0,
        shareImage: null,
        exchange_bg: "",
        // 优惠券使用说明
        content: "",
        // 使用次数
        usage_count: 1,
        price: 0,
        nprice: 0
      },
          festivalOptions: [
        { value: '01-01', label: '元旦' },
        { value: '02-14', label: '情人节' },
        { value: '03-08', label: '妇女节' },
        { value: '05-01', label: '劳动节' },
        { value: '06-01', label: '儿童节' },
        { value: '09-10', label: '教师节' },
        { value: '10-01', label: '国庆节' },
        { value: '12-25', label: '圣诞节' },
        // 农历节日
        { value: 'lunar-01-01', label: '春节' },
        { value: 'lunar-01-15', label: '元宵节' },
        { value: 'lunar-05-05', label: '端午节' },
        { value: 'lunar-07-07', label: '七夕节' },
        { value: 'lunar-08-15', label: '中秋节' },
        { value: 'lunar-09-09', label: '重阳节' }
      ],
      list: {},
      /*是否正在加载*/
      loading: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 背景图上传开关
      isBgUpload: false,
      bg_type: "",

      /*富文本框配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*获取用户是否显示*/
      open_getuser: false,
      /*选择的用户列表*/
      referee: "",
             userDialogVisible: false,

    };
  },
  mounted(){
    // this.getUser()
  },
  created() {
    let coupon_id = this.$route.query.coupon_id;
    this.getData(coupon_id);
    // this.getUser()
  },
  watch: {
  'form.user_range': function(newVal) {
    if (newVal === 1) { // 全部用户
      this.form.total_num = -1;
    } else if (newVal === 2) { // 随机用户
      this.form.total_num = 1;
    } else { // 指定用户
      this.form.total_num = this.form.user.length || 0;
    }
  },
  'form.user': function(newVal) {
    if (this.form.user_range === 3) {
      this.form.total_num = newVal.length;
    }
  }
},
  methods: {
     // 获取节日日期
    getFestivalDate(value) {
      if (value.startsWith('lunar-')) {
        return '农历' + value.replace('lunar-', '').replace('-', '月') + '日';
      }
      return value.replace('-', '月') + '日';
    },
   validateTotalNum(rule, value, callback) {
    if (this.form.user_range === 1) { // 全部用户
      if (value !== -1 && value <= 0) {
        callback(new Error('全部用户模式下，发放总数必须为-1或大于0'));
      } else {
        callback();
      }
    } else if (this.form.user_range === 2) { // 随机用户
      if (value <= 0) {
        callback(new Error('随机用户模式下，发放总数必须大于0'));
      } else {
        callback();
      }
    } else { // 指定用户
      if (this.form.user.length === 0) {
        callback(new Error('请先选择指定用户'));
      } else {
        // 指定用户模式下，发放总数自动等于选择的用户数
        this.form.total_num = this.form.user.length;
        callback();
      }
    }
  },
    // 删除用户
    deleteReferee() {
      this.referee = "";
      this.form.user_referee_id = 0;
    },
     handleUserRangeChange(val) {
    if(val !== 3) this.form.user = []
  },

  openUserDialog() {
    // 调用接口获取用户列表
      UserApi.userlist().then(res => {
      this.userList = res.data.list.data.map(user => ({
        key: user.user_id,
        label: `${user.nickName}(${user.mobile})`
      }))
      this.userDialogVisible = true
    })
  },
  confirmUserSelection() {
    this.userDialogVisible = false
  },
    /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != "error") {
        this.referee = e.params[0];
        this.form.user_referee_id = e.params[0].user_id;
      }
      this.open_getuser = false;
    },
    getData(coupon_id) {
      let self = this;
      CouponApi.couponDetail(
        {
          coupon_id: coupon_id
        },
        true
      )
        .then(data => {
          let obj = data.data.detail;
          // this.form.hongbao_name = data.data.detail.hongbao_name || "默认名称";
          const originalGtaskId = obj.gtask_id || 0;
          //选中
          obj.color = data.data.detail.color.value;
          obj.coupon_type = data.data.detail.coupon_type.value;
          // obj.pickupCardProduct = data.data.detail.pickupCardProduct
          console.log(data.data.detail);
          self.form.gtask_id = originalGtaskId;
          self.form = formatModel(self.form, obj);
          self.form.user = Array.isArray(data.data.detail.user) 
  ? data.data.detail.user.map(Number) 
  : [];
          console.log('user1',self.form.user);
          
          self.form.tableData = [];
          if (
            data.data.detail.pickupCardProduct &&
            data.data.detail.pickupCardProduct.length > 0
          ) {
            self.form.tableData = mergeTable(
              data.data.detail.pickupCardProduct
            );
          }
          self.form.product_del_ids = [];
          self.loading = false;
          self.referee = data.data.detail.referee;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*修改*/
    onSubmit() {
      let self = this;
      let form = self.form;
      if (Number(form.coupon_type) === 30) {
        form.product_list = self.tableFormat(self.form.tableData);
      }
     if (Number(this.form.coupon_type) === 100) {
        if (!this.form.festival_name) {
          this.$message.error('请选择节日日期');
          return false;
        }
        
        if (this.form.festival_name === 'custom' && !this.form.custom_festival_date) {
          this.$message.error('请选择自定义日期');
          return false;
        }
        
        // 如果是自定义日期，将值赋给festival_name
        if (this.form.festival_name === 'custom') {
          this.form.festival_name = this.form.custom_festival_date;
        }
      }
      if (Number(form.coupon_type) === 50) {
        form.gtask_id = form.gtask_id || 0;
      } else {
        form.gtask_id = 0;
      }
       if (this.form.user_range === 3) {
        if (this.form.user.length === 0) {
          this.$message.error('请选择指定用户');
          return false;
        }
        this.form.total_num = this.form.user.length;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          console.log(form);
          CouponApi.editCoupon(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，修改成功",
                type: "success"
              });
              self.$router.push("/plus/coupon/index");
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          self.loading = false;
        }
      });
    },
    /*表格数据格式化*/
    tableFormat(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id: item.assemble_product_sku_id,
          product_price: item.product_price,
          sales_initial: item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      if (curItem && curItem.spec_list) {
        curItem.spec_list = spec_list;
      }
      curItem && newList.push(curItem);
      return newList;
    },
    /*取消*/
    cancelFunc() {
      this.$router.push({
        path: "/plus/coupon/index"
      });
    },
    // 上传详情附加图
    returnBgImgFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        console.log(this.bg_type);
        console.log(e[0]);
        if (this.bg_type == "bg") {
          this.form.bgImage = e[0];
          this.form.bg_image = e[0].file_id;
        } else {
          if (this.bg_type == "exchange_bg") {
            // exchange_bg file_path
            this.form.exchange_bg = e[0].file_path;
          } else {
            this.form.shareImage = e[0];
            this.form.share_image = e[0].file_id;
          }
        }
      }
      this.isBgUpload = false;
    },
    bgUpload(bg_type) {
      this.bg_type = bg_type;
      console.log(this.bg_type);
      this.isBgUpload = true;
    },
    deleteBgImg(bg_type) {
      if (bg_type == "bg") {
        this.form.bg_image = 0;
        this.form.bgImage = null;
      } else {
        if (this.bg_type == "exchange_bg") {
          // exchange_bg file_path
          this.form.exchange_bg = "";
        } else {
          this.form.share_image = 0;
          this.form.shareImage = null;
        }
      }
    },
    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },
    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.content = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}
.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;
  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}
.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;
  img {
    width: 110px;
    //height: 110px;
  }
}
.image-box:hover .delete-btn {
  display: block;
}
.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
.festival-select {
  width: 100%;
  max-width: 400px;
}
.d-s-c {
  display: flex;
  align-items: center;
}

.d-s-c > * {
  flex: 1;
}

.d-s-c > *:not(:last-child) {
  margin-right: 10px;
}

.festival-select .el-select-dropdown__item {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/edit.vue